export const INSECT = [
  "Acacia-ants",
  "Acorn-plum gall",
  "Aerial yellowjacket",
  "Africanized honey bee",
  "Allegheny mound ant",
  "Almond stone wasp",
  "Ant",
  "Arboreal ant",
  "Argentine ant",
  "Asian paper wasp",
  "Baldfaced hornet",
  "Bee",
  "Bigheaded ant",
  "Black and yellow mud dauber",
  "Black carpenter ant",
  "Black imported fire ant",
  "Blue horntail woodwasp",
  "Blue orchard bee",
  "Braconid wasp",
  "Bumble bee",
  "Carpenter ant",
  "Carpenter wasp",
  "Chalcid wasp",
  "Cicada killer",
  "Citrus blackfly parasitoid",
  "Common paper wasp",
  "Crazy ant",
  "Cuckoo wasp",
  "Cynipid gall wasp",
  "Eastern Carpenter bee",
  "Eastern yellowjacket",
  "Elm sawfly",
  "Encyrtid wasp",
  "Erythrina gall wasp",
  "Eulophid wasp",
  "European hornet",
  "European imported fire ant",
  "False honey ant",
  "Fire ant",
  "Forest bachac",
  "Forest yellowjacket",
  "German yellowjacket",
  "Ghost ant",
  "Giant ichneumon wasp",
  "Giant resin bee",
  "Giant wood wasp",
  "Golden northern bumble bee",
  "Golden paper wasp",
  "Gouty oak gall",
  "Grass Carrying Wasp",
  "Great black wasp",
  "Great golden digger wasp",
  "Hackberry nipple gall parasitoid",
  "Honey bee",
  "Horned oak gall",
  "Horse guard wasp",
  "Horse guard wasp",
  "Hunting wasp",
  "Ichneumonid wasp",
  "Keyhole wasp",
  "Knopper gall",
  "Large garden bumble bee",
  "Large oak-apple gall",
  "Leafcutting bee",
  "Little fire ant",
  "Little yellow ant",
  "Long-horned bees",
  "Long-legged ant",
  "Macao paper wasp",
  "Mallow bee",
  "Marble gall",
  "Mossyrose gall wasp",
  "Mud-daubers",
  "Multiflora rose seed chalcid",
  "Oak apple gall wasp",
  "Oak rough bulletgall wasp",
  "Oak saucer gall",
  "Oak shoot sawfly",
  "Odorous house ant",
  "Orange-tailed bumble bee",
  "Orangetailed potter wasp",
  "Oriental chestnut gall wasp",
  "Paper wasp",
  "Pavement ant",
  "Pigeon tremex",
  "Pip gall wasp",
  "Prairie yellowjacket",
  "Pteromalid wasp",
  "Pyramid ant",
  "Raspberry Horntail",
  "Red ant",
  "Red carpenter ant",
  "Red harvester ant",
  "Red imported fire ant",
  "Red wasp",
  "Red wood ant",
  "Red-tailed wasp",
  "Reddish carpenter ant",
  "Rough harvester ant",
  "Sawfly parasitic wasp",
  "Scale parasitoid",
  "Silky ant",
  "Sirex woodwasp",
  "Siricid woodwasp",
  "Smaller yellow ant",
  "Southeastern blueberry bee",
  "Southern fire ant",
  "Southern yellowjacket",
  "Sphecid wasp",
  "Stony gall",
  "Sweat bee",
  "Texas leafcutting ant",
  "Tiphiid wasp",
  "Torymid wasp",
  "Tramp ant",
  "Valentine ant",
  "Velvet ant",
  "Vespid wasp",
  "Weevil parasitoid",
  "Western harvester ant",
  "Western paper wasp",
  "Western thatching ant",
  "Western yellowjacket",
  "White-horned horntail",
  "Willow shoot sawfly",
  "Woodwasp",
  "Wool sower gall maker",
  "Yellow and black potter wasp",
  "Yellow Crazy Ant",
  "Yellow-horned horntail",
];
